import React from 'react';
import ReactDOM from 'react-dom';
import { X, Plus } from 'lucide-react';

const AddEventModal = ({ 
  show, 
  onClose, 
  eventForm, 
  handleFormChange, 
  handleSubmitEvent,
  formError,
  formSuccess
}) => {
  if (!show) return null;
  
  return ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10001,
            padding: '1rem'
          }}
          onClick={() => onClose()}
        >
          <div
            style={{
              width: '90%',
              maxWidth: '600px',
              maxHeight: '90vh',
              background: 'rgba(26, 26, 46, 0.98)',
              borderRadius: '16px',
              overflow: 'hidden',
              border: '3px solid #00ffff',
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              padding: '1.5rem 2rem',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0
            }}>
              <h2 style={{
                fontSize: '1.75rem',
                fontWeight: '700',
                color: '#fff',
                margin: 0,
                background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                ✨ Add Event
              </h2>
              <button
                onClick={() => onClose()}
                style={{
                  background: 'rgba(255, 0, 128, 0.2)',
                  border: '1px solid rgba(255, 0, 128, 0.4)',
                  color: '#ff0080',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.25rem',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              >
                <X size={18} />
              </button>
            </div>

            {/* Modal Content - Form */}
            <div 
              className="event-form-scrollable"
              style={{ 
                padding: '2rem', 
                overflowY: 'auto', 
                flex: 1,
                WebkitOverflowScrolling: 'touch'
              }}
            >
              <style>{`
                .event-form-scrollable::-webkit-scrollbar {
                  width: 8px;
                }
                .event-form-scrollable::-webkit-scrollbar-track {
                  background: rgba(0, 0, 0, 0.2);
                  border-radius: 4px;
                }
                .event-form-scrollable::-webkit-scrollbar-thumb {
                  background: rgba(0, 255, 255, 0.3);
                  border-radius: 4px;
                }
                .event-form-scrollable::-webkit-scrollbar-thumb:hover {
                  background: rgba(0, 255, 255, 0.5);
                }
              `}</style>

              {formSuccess ? (
                <div style={{
                  background: 'rgba(0, 255, 0, 0.1)',
                  border: '1px solid rgba(0, 255, 0, 0.3)',
                  borderRadius: '12px',
                  padding: '2rem',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                  <h3 style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#00ff00',
                    marginBottom: '1rem'
                  }}>
                    Event Added Successfully!
                  </h3>
                  <p style={{
                    fontSize: '1rem',
                    color: 'rgba(255, 255, 255, 0.8)',
                    margin: 0
                  }}>
                    Your event is now live on the calendar.
                  </p>
                </div>
              ) : (
                <form onSubmit={(e) => { e.preventDefault(); handleSubmitEvent(); }}>
                  {/* Error Message */}
                  {formError && (
                    <div style={{
                      background: 'rgba(255, 0, 0, 0.1)',
                      border: '1px solid rgba(255, 0, 0, 0.3)',
                      borderRadius: '8px',
                      padding: '1rem',
                      marginBottom: '1.5rem',
                      color: '#ff4444',
                      fontSize: '0.95rem'
                    }}>
                      {formError}
                    </div>
                  )}

                  {/* Event Name */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                      Event Name *
                    </label>
                    <input
                      type="text"
                      value={eventForm.event_name}
                      onChange={(e) => handleFormChange('event_name', e.target.value)}
                      placeholder="e.g., Friday Night Live Set"
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        background: 'rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Venue Name */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                      Venue/Platform Name *
                    </label>
                    <input
                      type="text"
                      value={eventForm.venue_name}
                      onChange={(e) => handleFormChange('venue_name', e.target.value)}
                      placeholder="e.g., Club Noir or Twitch"
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        background: 'rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Row: Event Type & Genre */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div>
                      <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                        Event Type *
                      </label>
                      <select
                        value={eventForm.event_type}
                        onChange={(e) => handleFormChange('event_type', e.target.value)}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          background: 'rgba(0, 0, 0, 0.4)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: '8px',
                          color: '#fff',
                          fontSize: '1rem',
                          cursor: 'pointer'
                        }}
                      >
                        <option value="club-show">🎧 Club/Bar Show</option>
                        <option value="festival">🎪 Festival</option>
                        <option value="livestream">📡 Livestream</option>
                        <option value="private-event">💒 Private Event</option>
                      </select>
                    </div>

                    <div>
                      <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                        Genre *
                      </label>
                      <select
                        value={eventForm.genre}
                        onChange={(e) => handleFormChange('genre', e.target.value)}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          background: 'rgba(0, 0, 0, 0.4)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: '8px',
                          color: '#fff',
                          fontSize: '1rem',
                          cursor: 'pointer'
                        }}
                      >
                        <option value="house">House</option>
                        <option value="techno">Techno</option>
                        <option value="hip-hop">Hip Hop</option>
                        <option value="edm">EDM</option>
                        <option value="open-format">Open Format</option>
                        <option value="drum-and-bass">Drum & Bass</option>
                        <option value="dubstep">Dubstep</option>
                        <option value="trance">Trance</option>
                      </select>
                    </div>
                  </div>

                  {/* Location */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                      Location *
                    </label>
                    <input
                      type="text"
                      value={eventForm.location}
                      onChange={(e) => handleFormChange('location', e.target.value)}
                      placeholder="e.g., Los Angeles, CA or 'Online'"
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        background: 'rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Row: Date & Time */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div>
                      <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                        Event Date *
                      </label>
                      <input
                        type="date"
                        value={eventForm.event_date}
                        onChange={(e) => handleFormChange('event_date', e.target.value)}
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          background: 'rgba(0, 0, 0, 0.4)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: '8px',
                          color: '#fff',
                          fontSize: '1rem'
                        }}
                      />
                    </div>

                    <div>
                      <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                        Event Time *
                      </label>
                      <input
                        type="text"
                        value={eventForm.event_time}
                        onChange={(e) => handleFormChange('event_time', e.target.value)}
                        placeholder="e.g., 9:00 PM - 2:00 AM"
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          background: 'rgba(0, 0, 0, 0.4)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: '8px',
                          color: '#fff',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  </div>

                  {/* Description */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                      Description *
                    </label>
                    <textarea
                      value={eventForm.description}
                      onChange={(e) => handleFormChange('description', e.target.value)}
                      placeholder="Tell people about your event, what to expect, vibe, etc..."
                      rows={4}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        background: 'rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '1rem',
                        resize: 'vertical',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  {/* Ticket URL */}
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                      Ticket/Info URL (Optional)
                    </label>
                    <input
                      type="url"
                      value={eventForm.ticket_url}
                      onChange={(e) => handleFormChange('ticket_url', e.target.value)}
                      placeholder="https://..."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        background: 'rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '8px',
                        color: '#fff',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  {/* Stream URL (show only for livestream) */}
                  {eventForm.event_type === 'livestream' && (
                    <div style={{ marginBottom: '1.5rem' }}>
                      <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                        Stream URL (Optional)
                      </label>
                      <input
                        type="url"
                        value={eventForm.stream_url}
                        onChange={(e) => handleFormChange('stream_url', e.target.value)}
                        placeholder="https://twitch.tv/... or https://youtube.com/..."
                        style={{
                          width: '100%',
                          padding: '0.75rem',
                          background: 'rgba(0, 0, 0, 0.4)',
                          border: '1px solid rgba(255, 255, 255, 0.1)',
                          borderRadius: '8px',
                          color: '#fff',
                          fontSize: '1rem'
                        }}
                      />
                    </div>
                  )}

                  {/* Recurring Event Section */}
                  <div style={{
                    marginBottom: '1.5rem',
                    padding: '1rem',
                    background: 'rgba(255, 0, 255, 0.1)',
                    border: '1px solid rgba(255, 0, 255, 0.3)',
                    borderRadius: '8px'
                  }}>
                    <label style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      color: '#fff',
                      cursor: 'pointer',
                      marginBottom: eventForm.is_recurring ? '1rem' : 0
                    }}>
                      <input
                        type="checkbox"
                        checked={eventForm.is_recurring}
                        onChange={(e) => handleFormChange('is_recurring', e.target.checked)}
                        style={{
                          width: '18px',
                          height: '18px',
                          cursor: 'pointer'
                        }}
                      />
                      <span style={{ fontWeight: '600' }}>🔁 Recurring Event</span>
                    </label>

                    {eventForm.is_recurring && (
                      <>
                        <div style={{
                          padding: '0.75rem',
                          background: 'rgba(255, 165, 0, 0.1)',
                          border: '1px solid rgba(255, 165, 0, 0.3)',
                          borderRadius: '6px',
                          fontSize: '0.85rem',
                          color: 'rgba(255, 255, 255, 0.8)',
                          marginBottom: '1rem'
                        }}>
                          ⚠️ This will automatically create events on the same day/time based on your recurring settings. For different days, please create separate events.
                        </div>

                        <div>
                          <label style={{ display: 'block', color: '#fff', marginBottom: '0.5rem', fontWeight: '600' }}>
                            Recurring Type
                          </label>
                          <select
                            value={eventForm.recurring_type}
                            onChange={(e) => handleFormChange('recurring_type', e.target.value)}
                            style={{
                              width: '100%',
                              padding: '0.75rem',
                              background: 'rgba(0, 0, 0, 0.4)',
                              border: '1px solid rgba(255, 255, 255, 0.1)',
                              borderRadius: '8px',
                              color: '#fff',
                              fontSize: '1rem',
                              cursor: 'pointer'
                            }}
                          >
                            <option value="weekly">Weekly (once a week)</option>
                            <option value="bi-weekly">Bi-Weekly (twice a month)</option>
                            <option value="monthly">Monthly (once a month)</option>
                          </select>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      padding: '1rem',
                      background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#fff',
                      fontSize: '1.1rem',
                      fontWeight: '700',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    Add Event to Calendar
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>,
    document.body
  );
};

export default AddEventModal;
